import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Inscripcion from "@/pages/Inscripcion";
import Confirmacion from "@/pages/Confirmacion";
import Comprobante from "@/pages/Comprobante";
import AvisoPrivacidad from "@/pages/AvisoPrivacidad";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminDetalle from "@/pages/AdminDetalle";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/inscripcion" element={<Inscripcion />} />
          <Route path="/reanudar/:resumeId" element={<Inscripcion />} />
          <Route path="/confirmacion/:folio" element={<Confirmacion />} />
          <Route path="/comprobante/:folio" element={<Comprobante />} />
          <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/inscripciones/:id" element={<AdminDetalle />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
